import type { IconSvgObject } from './types';

const LocationAdd01Icon: IconSvgObject = [
  ["path", { d: "M15.5 11L12 11M12 11L8.5 11M12 11L12 14.5M12 11L12 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 11C21 18 12 22 12 22C12 22 3 18 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LocationAdd01Icon;
